export default __webpack_public_path__ + "static/media/language.014e9817.png";